import {
    getBoardList,
    getBoard,
} from "../apis/api_board.js";

import { listMode } from '../utils/table';

const state = {
    filters: { mode: listMode.list, showDt:'', showYn: '', id:0},
    items: [], 
};

const getters = {
};

const mutations = {
    SET_BOARD_LIST(state, items){
        state.items = items;
    },

    SET_BOARD(state, payload) {
        state.item = payload
    },

    CLEAR_BOARD(state) {
        state.item = {};
    },
};

const actions = {

    async GET_BOARD_LIST({ state, commit }, filters) {

        let params = { ...state.filters, ...filters };

        try {
            const response = await getBoardList(params);
            commit('SET_BOARD_LIST', response.data.data.content)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_BOARD(context, id) {
        try {
            const response = await getBoard(id);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },    
};

export default {mutations, state, actions, getters};